import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { environment } from '../../../../../../../environments/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { ContaContabilResponse } from './conta-contabil.model';

@Injectable({ providedIn: 'root' })
export class ContaContabilService extends BaseService {
    private readonly PATH = SICOM_PATHS.financeiro.arrecadacao.contaContabil;
    private contas$?: Observable<ContaContabilResponse[]>;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    /**
     * Lista todo o plano de contas. O resultado é cacheado e compartilhado entre
     * todos os consumidores (uma única requisição por sessão). Em caso de erro o
     * cache é descartado, permitindo nova tentativa na próxima chamada.
     */
    listar(): Observable<ContaContabilResponse[]> {
        if (!this.contas$) {
            this.contas$ = this.http.get<ContaContabilResponse[]>(`${this.rootUrl}${this.PATH}`).pipe(
                catchError((err) => {
                    this.contas$ = undefined;
                    return throwError(() => err);
                }),
                shareReplay({ bufferSize: 1, refCount: false })
            );
        }
        return this.contas$;
    }
}
